import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton: React.FC = () => {
  const Icon = FaWhatsapp as unknown as React.FC<{ size?: number }>;

  return (
    <a
      href="https://wa.me/4917657122695"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 p-4 rounded-full text-white shadow-lg
      transition-transform duration-300 hover:scale-110"
    >
      <Icon size={28} />
    </a>
  );
};

export default WhatsAppButton;
